// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__SRZgW","boxTitle":"Qualiphy_boxTitle__33Ne4","box":"Qualiphy_box__2iz9F","toggleWrap":"Qualiphy_toggleWrap__1aBkp"};